"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgAdjustOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16.86 6a4 4 0 00-7.72 0H4v2h5.14a4 4 0 007.72 0H28V6zM13 9a2 2 0 112-2 2 2 0 01-2 2zM11 21a4 4 0 00-3.86 3H4v2h3.14a4 4 0 007.72 0H28v-2H14.86A4 4 0 0011 21zm0 6a2 2 0 112-2 2 2 0 01-2 2zM21 12a4 4 0 00-3.86 3H4v2h13.14a4 4 0 007.72 0H28v-2h-3.14A4 4 0 0021 12zm0 6a2 2 0 112-2 2 2 0 01-2 2z" })));
}
exports.default = SvgAdjustOutline;
//# sourceMappingURL=AdjustOutline.js.map